import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import { GetCustomer } from "api/models/request/customer/customer";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type { AutoCompleteProvider } from "./factory";

export const customerAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword) => {
    return customerBusiness.searchCustomerAsOptionItems(keyword);
  },
  searchOptionItemsPagedAsync: async (keyword, request) => {
    const customers = await customerBusiness.getLists<GetCustomer>({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
      isDisabled: false,
    });

    return {
      items: mapToDistinctOptionItems(
        customers.items,
        (item) => item.id,
        (item) => item.dealingName,
      ),
      totalCount: customers.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const customer = await customerBusiness.getById(normalizedId);
      if (!customer?.id) {
        return null;
      }

      return {
        value: customer.id,
        label: customer.dealingName || normalizedId,
      };
    } catch {
      return null;
    }
  },
};
